/* Scart - Réseau d'installateurs : carte Google Maps + liaison liste <-> markers.
   Chargé par sections/scart-installers.liquid. Google Maps JS API appelle
   window.initScartInstallersMap en callback (script async). */
(function () {
  'use strict';

  var FR = (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0;
  var T = {
    directions: FR ? 'Itinéraire' : 'Directions',
    website: FR ? 'Site web' : 'Website',
    call: FR ? 'Appeler' : 'Call'
  };

  // Style carte épuré (premium, peu saturé)
  var MAP_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
    { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: '#cfcfcf' }] },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road.arterial', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#e8e8e8' }] },
    { featureType: 'road.local', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#dbe7ef' }] }
  ];

  function pinIcon(active) {
    var fill = active ? '#8c0f24' : '#c41e3a';
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="46" viewBox="0 0 34 46">' +
      '<path fill="' + fill + '" stroke="#fff" stroke-width="2" d="M17 1C8.7 1 2 7.7 2 16c0 10.5 13.2 27 14.1 28.1.5.6 1.3.6 1.8 0C18.8 43 32 26.5 32 16 32 7.7 25.3 1 17 1z"/>' +
      '<circle cx="17" cy="16" r="6" fill="#fff"/></svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(active ? 40 : 34, active ? 54 : 46),
      anchor: new google.maps.Point((active ? 40 : 34) / 2, active ? 54 : 46)
    };
  }

  function iwHtml(d) {
    var addr = [d.adresse, (d.code_postal + ' ' + d.ville).trim(), d.pays].filter(Boolean).join(', ');
    var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addr);
    var html = '<div class="scart-inst__iw">' +
      '<p class="scart-inst__iw-name">' + d.nom + '</p>' +
      (d.specialite ? '<p class="scart-inst__iw-addr">' + d.specialite + '</p>' : '') +
      '<p class="scart-inst__iw-addr">' + addr + '</p>' +
      '<a class="scart-inst__iw-link" href="' + dir + '" target="_blank" rel="noopener">' + T.directions + ' &rsaquo;</a>';
    if (d.site_web) {
      html += ' &nbsp; <a class="scart-inst__iw-link" href="' + d.site_web + '" target="_blank" rel="noopener">' + T.website + ' &rsaquo;</a>';
    }
    html += '</div>';
    return html;
  }

  window.initScartInstallersMap = function () {
    var root = document.querySelector('[data-scart-installers]');
    if (!root || !window.google || !google.maps) return;
    var mapEl = root.querySelector('[data-inst-map]');
    var dataEl = root.querySelector('[data-inst-data]');
    if (!mapEl || !dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    data = (data || []).filter(function (d) { return d.lat && d.lng; });
    if (!data.length) { return; }

    var map = new google.maps.Map(mapEl, {
      zoom: 6,
      center: { lat: 46.7, lng: 2.4 },
      styles: MAP_STYLE,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative'
    });

    var iw = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();
    var markers = {};
    var cards = {};
    var activeHandle = null;

    root.querySelectorAll('[data-inst-card]').forEach(function (card) {
      cards[card.getAttribute('data-inst-card')] = card;
    });

    function setActive(handle, pan) {
      if (activeHandle && markers[activeHandle]) markers[activeHandle].setIcon(pinIcon(false));
      if (activeHandle && cards[activeHandle]) cards[activeHandle].classList.remove('is-active');
      activeHandle = handle;
      if (!handle) { iw.close(); return; }
      var m = markers[handle];
      if (m) {
        m.setIcon(pinIcon(true));
        iw.setContent(iwHtml(m.__data));
        iw.open(map, m);
        if (pan) {
          map.panTo(m.getPosition());
          if (map.getZoom() < 9) map.setZoom(11);
        }
      }
      if (cards[handle]) cards[handle].classList.add('is-active');
    }

    data.forEach(function (d) {
      var pos = { lat: parseFloat(d.lat), lng: parseFloat(d.lng) };
      var marker = new google.maps.Marker({
        position: pos,
        map: map,
        title: d.nom,
        icon: pinIcon(false)
      });
      marker.__data = d;
      markers[d.handle] = marker;
      bounds.extend(pos);
      marker.addListener('click', function () {
        setActive(d.handle, true);
        if (cards[d.handle]) {
          cards[d.handle].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });

    google.maps.event.addListenerOnce(map, 'idle', function () {
      map.fitBounds(bounds, 48);
      if (data.length === 1) map.setZoom(12);
    });

    // Click sur une carte de la liste -> active le marker
    Object.keys(cards).forEach(function (handle) {
      cards[handle].addEventListener('click', function (e) {
        // laisser les liens (tel/site/itinéraire) fonctionner normalement
        if (e.target.closest('a')) return;
        setActive(handle, true);
      });
    });

    // ===== Recherche ville/CP + "autour de moi" (filtre liste + markers) =====
    (function () {
      var input = root.querySelector('[data-inst-input]');
      var nearBtn = root.querySelector('[data-inst-near]');
      var countEl = root.querySelector('[data-inst-count]');
      var emptyEl = root.querySelector('[data-inst-empty]');
      var lis = Array.prototype.slice.call(root.querySelectorAll('[data-inst-card]'));
      var uls = root.querySelectorAll('[data-inst-ul]');

      function norm(s) {
        return (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      }
      function word(n) {
        if (FR) return n > 1 ? 'ateliers partenaires' : 'atelier partenaire';
        return n > 1 ? 'partner workshops' : 'partner workshop';
      }
      function setCount(n, q) {
        if (countEl) countEl.textContent = n + ' ' + word(n);
        if (emptyEl) {
          emptyEl.hidden = n !== 0;
          if (n === 0) {
            emptyEl.textContent = FR
              ? 'Aucun atelier pour « ' + q + ' ». Essayez une autre ville.'
              : 'No workshop for "' + q + '". Try another city.';
          }
        }
      }
      function fitVisible() {
        var b = new google.maps.LatLngBounds(), n = 0;
        lis.forEach(function (li) {
          if (li.hidden) return;
          var m = markers[li.getAttribute('data-inst-card')];
          if (m && m.getVisible()) { b.extend(m.getPosition()); n++; }
        });
        if (n === 1) { map.setCenter(b.getCenter()); map.setZoom(11); }
        else if (n > 1) { map.fitBounds(b, 48); }
      }
      function apply(q) {
        var nq = norm(q), shown = 0;
        lis.forEach(function (li) {
          var match = !nq || norm(li.getAttribute('data-search')).indexOf(nq) !== -1;
          li.hidden = !match;
          var m = markers[li.getAttribute('data-inst-card')];
          if (m) m.setVisible(match);
          if (match) shown++;
        });
        // masque un groupe pays devenu vide (cas multi-pays)
        Array.prototype.forEach.call(uls, function (ul) {
          var any = ul.querySelector('[data-inst-card]:not([hidden])');
          ul.hidden = !any;
          var h2 = ul.previousElementSibling;
          if (h2 && h2.classList.contains('scart-inst__country')) h2.hidden = !any;
        });
        setCount(shown, q);
        fitVisible();
      }

      if (input) {
        var t;
        input.addEventListener('input', function () {
          clearTimeout(t);
          t = setTimeout(function () { apply(input.value); }, 160);
        });
      }

      function dist(a1, o1, a2, o2) {
        var R = 6371, dLa = (a2 - a1) * Math.PI / 180, dLo = (o2 - o1) * Math.PI / 180;
        var s = Math.sin(dLa / 2) * Math.sin(dLa / 2) +
          Math.cos(a1 * Math.PI / 180) * Math.cos(a2 * Math.PI / 180) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
        return 2 * R * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
      }
      if (nearBtn && navigator.geolocation) {
        nearBtn.addEventListener('click', function () {
          nearBtn.classList.add('is-loading');
          navigator.geolocation.getCurrentPosition(function (pos) {
            nearBtn.classList.remove('is-loading');
            var ula = pos.coords.latitude, ulo = pos.coords.longitude;
            if (input) input.value = '';
            apply('');
            var sorted = lis.map(function (li) {
              return { li: li, d: dist(ula, ulo, parseFloat(li.getAttribute('data-lat')), parseFloat(li.getAttribute('data-lng'))) };
            }).sort(function (a, b) { return a.d - b.d; });
            if (uls.length === 1) {
              sorted.forEach(function (x) { uls[0].appendChild(x.li); });
            }
            var b = new google.maps.LatLngBounds();
            b.extend({ lat: ula, lng: ulo });
            sorted.slice(0, 3).forEach(function (x) {
              var m = markers[x.li.getAttribute('data-inst-card')];
              if (m) b.extend(m.getPosition());
            });
            map.fitBounds(b, 60);
            var nearest = sorted[0];
            if (nearest) {
              setActive(nearest.li.getAttribute('data-inst-card'), false);
              nearest.li.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }, function () {
            nearBtn.classList.remove('is-loading');
          }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
        });
      } else if (nearBtn) {
        nearBtn.style.display = 'none';
      }
    })();

    iw.addListener('closeclick', function () {
      if (activeHandle && markers[activeHandle]) markers[activeHandle].setIcon(pinIcon(false));
      if (activeHandle && cards[activeHandle]) cards[activeHandle].classList.remove('is-active');
      activeHandle = null;
    });
  };

  // Encart "Retour au produit" : affiché UNIQUEMENT si on arrive via le lien explicite
  // d'une fiche produit (params ?return + pt/pp/pi). Le footer n'a pas ces params -> rien.
  // Mini-carte produit (image, titre, prix) construite en JS depuis les params (XSS-safe :
  // textContent pour les textes, src image validée same-CDN).
  function initInstallerReturn() {
    var root = document.querySelector('[data-scart-installers]');
    if (!root) return;
    var slot = root.querySelector('[data-inst-return]');
    if (!slot) return;
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    var ret = p.get('return');
    if (!ret || !/^\/[^/]/.test(ret) || ret.indexOf('://') !== -1) return;
    slot.setAttribute('href', ret);

    var title = p.get('pt');
    if (title) {
      var price = p.get('pp');
      var img = p.get('pi');
      slot.textContent = '';
      slot.classList.add('scart-inst__return--card');

      var imgOk = img && /^(https?:)?\/\//.test(img) && img.indexOf('/cdn/') !== -1;
      if (imgOk) {
        var im = document.createElement('img');
        im.src = img.indexOf('//') === 0 ? 'https:' + img : img;
        im.alt = ''; im.loading = 'lazy';
        im.className = 'scart-inst__return-img';
        slot.appendChild(im);
      }
      var box = document.createElement('div');
      box.className = 'scart-inst__return-box';
      var kicker = document.createElement('span');
      kicker.className = 'scart-inst__return-kicker';
      kicker.textContent = FR ? '← Retour au produit' : '← Back to product';
      var t = document.createElement('span');
      t.className = 'scart-inst__return-title';
      t.textContent = title;
      box.appendChild(kicker);
      box.appendChild(t);
      if (price) {
        var pr = document.createElement('span');
        pr.className = 'scart-inst__return-price';
        pr.textContent = price;
        box.appendChild(pr);
      }
      slot.appendChild(box);
    }
    slot.hidden = false;
  }
  if (document.readyState !== 'loading') initInstallerReturn();
  else document.addEventListener('DOMContentLoaded', initInstallerReturn);
})();
